import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Auth } from "aws-amplify";
import { Observable } from "rxjs";

@Injectable()
export class RootGuard implements CanActivate {
  constructor(
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (state.url === '/login') {
      return true;
    }
    return Auth.currentAuthenticatedUser()
    .catch(err => {
      return this.router.createUrlTree(['/login']);
    })
    .then(user => {
      if (user instanceof UrlTree) {
        return user;
      }
      return true;
    })
  }

}